import { render, staticRenderFns } from "./AxFolder.vue?vue&type=template&id=4ca63c5a&functional=true&"
import script from "./AxFolder.vue?vue&type=script&lang=ts&"
export * from "./AxFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports